import * as React from "react"
import { Input } from "@/components/ui/input"
import { cn } from "@/lib/utils"

interface CurrencyInputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "value" | "onChange"> {
  value: number | string
  onChange: (value: number) => void
}

export const CurrencyInput = React.forwardRef<HTMLInputElement, CurrencyInputProps>(
  ({ className, value, onChange, ...props }, ref) => {
    
    // Converte o valor numérico para string formatada para exibição
    const displayValue = React.useMemo(() => {
        if (value === "" || value === undefined || value === null) return "0,00";
        const numVal = typeof value === 'string' ? parseFloat(value) : value;
        if (isNaN(numVal)) return "0,00";
        
        return new Intl.NumberFormat('pt-BR', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(numVal);
    }, [value]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      // Remove tudo que não for dígito
      const rawValue = e.target.value.replace(/\D/g, "")
      // Divide por 100 para considerar os centavos
      const numericValue = Number(rawValue) / 100
      
      onChange(numericValue)
    }

    return (
      <Input
        ref={ref}
        className={cn("text-left font-mono", className)}
        value={displayValue}
        onChange={handleChange}
        inputMode="numeric"
        {...props}
      />
    )
  }
)
CurrencyInput.displayName = "CurrencyInput"
